import { get, put, post } from '../Services/http';
import { catchError } from './Error.action';
import { CART_LOAD_ERROR, CART_RECEIVE, CART_SHOW_INFO } from '../constants';
import { setLoading } from './DeliveryDate.action';

export const load = () => (dispatch, getState) => {
  return get('/api/cart')
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const clear = (abortController = null) => (dispatch) => {
  return post(`/api/cart/clear`, null, abortController)
    .then((response) => response.json())
    .then((cart) => dispatch(receive(cart)))
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
  type: CART_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receive = (cart) => ({
  type: CART_RECEIVE,
  payload: cart,
});

export const toggle = () => (dispatch, getState) => {
  dispatch(show(!getState().cart.showInfo));
};

const show = (visible) => ({
  type: CART_SHOW_INFO,
  payload: {
    showInfo: visible,
  },
});

export const update = (articleNumber, quantity, abortController = null) => (
  dispatch
) => {
  dispatch(setLoading(true));
  return put(`/api/cart/update`, { articleNumber, quantity }, abortController)
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart))
      dispatch(setLoading(false));
    })
    .catch((ex) => {
      dispatch(catchError(ex, (error) => loadError(error)));
      throw ex;
    });
};
